import CustomQuickFilterBox from '@components/ag-grid/CustomQuickFilterBox';
import { Loading } from '@components/atomic/atoms';
import CustomPaginationMui from '@components/materialComponents/CustomPaginationMui';
import { getProjectChecklistStagingTable } from '@lib/api';
import { useQuery } from '@tanstack/react-query';
import { ColDef } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';

interface ChecklistsStagingTableProps {
	entityType: string;
	projectId: string;
	subActiveKey: string;
	localeText: any;
	columnDefs: ColDef[];
	defaultColDef: ColDef;
	gridRef: React.RefObject<AgGridReact>;
	onGridReady: (params: any, gridRef: React.RefObject<AgGridReact>) => void;
	sbShow: React.ReactNode;
	batchState: string;
}

const ChecklistsStagingTable: React.FC<ChecklistsStagingTableProps> = ({
	entityType,
	projectId,
	subActiveKey,
	localeText,
	columnDefs,
	defaultColDef,
	gridRef,
	onGridReady,
	sbShow,
	batchState,
}) => {
	const [checklistsStaging, setChecklistsStaging] = React.useState<any[]>();
	const [checklistsStagingMeta, setChecklistsStagingMeta] = React.useState<any>({});
	const [isFirstResearch3, setIsFirstResearch3] = React.useState(true);
	const [isRefreshing, setIsRefreshing] = React.useState(false);
	const gridRefClStaging = React.useRef<AgGridReact>(null);

	const stagingChecklistsQuery = useQuery({
		queryKey: ['staging-checklists', entityType, projectId],
		queryFn: () => getProjectChecklistStagingTable(entityType, projectId, entityType + 'CLStaging'),
		enabled: subActiveKey === 'log-checklists' && !!projectId,
		refetchInterval: batchState === 'DOING' ? 5000 : false,
	});

	useEffect(() => {
		if (stagingChecklistsQuery.data) {
			setChecklistsStaging(stagingChecklistsQuery.data.data);
			setChecklistsStagingMeta({ meta: stagingChecklistsQuery.data.meta });
		}
	}, [stagingChecklistsQuery.data]);

	return (
		<>
			<Row className="align-items-center mb-4">
				<Col className="col-4">
					<CustomQuickFilterBox
						tableRef={gridRefClStaging}
						dataMeta={checklistsStagingMeta}
						setData={setChecklistsStaging}
						dataLength={checklistsStaging?.length}
						isFirstResearch={isFirstResearch3}
						setIsFirstResearch={setIsFirstResearch3}
						refTable={entityType + 'CLStaging'}
						isRefreshing={isRefreshing}
						setIsRefreshing={setIsRefreshing}
						isQuickFilterDisabled={false}
						setDataMeta={setChecklistsStagingMeta}
					/>
				</Col>
			</Row>

			<Row>
				<Col className="col-12">
					{Array.isArray(checklistsStaging) ? (
						<div className="ag-theme-alpine list-table" id="grid-wrapper">
							<AgGridReact
								ref={gridRefClStaging}
								columnDefs={columnDefs}
								rowData={checklistsStaging}
								defaultColDef={defaultColDef}
								domLayout="autoHeight"
								tooltipShowDelay={0}
								tooltipHideDelay={2000}
								tooltipMouseTrack={true}
								onGridReady={(e) => onGridReady(e, gridRefClStaging)}
								headerHeight={50}
								rowHeight={50}
								suppressCellFocus={true}
								animateRows={true}
								localeText={localeText}
							/>
							{Object.keys(checklistsStagingMeta).length > 0 && (
								<CustomPaginationMui
									dataMeta={checklistsStagingMeta}
									setData={setChecklistsStaging}
									setDataMeta={setChecklistsStagingMeta}
									refTable={entityType + 'CLStaging'}
									setIsFirstResearch={setIsFirstResearch3}
									setIsChangedPagination={() => {}}
								/>
							)}
						</div>
					) : (
						<Loading />
					)}
				</Col>
			</Row>
		</>
	);
};

export default ChecklistsStagingTable;
